import { connect } from 'pwa-helpers';
import { fetchCountryOptions, getCountryError, getCountryOptions, getCountryStatus, updateSelectedCountry } from './country';
import store from "../../store/store";
import { StoreState } from "../../store/store.interface";
import { customElement, property } from 'lit/decorators.js';
import { Select } from '../selector/selector';
import { ActionStatus } from '../../common/constants/action-status';
import { handleApiError } from '../../common/utils/api-utils';
import emit from '../../common/events';

/**
 * Select component to allow user to select a Country option. 
 * Country options are loaded via API
 */
@customElement('mhecomm-country-selector')
export class CountrySelect extends connect(store)(Select){

  @property()
  type ='';
  
  constructor() {
    super();
    this.defaultOptionFormValue = "";
    this.defaultOptionDisplayValue= "Choose a country";
    this.loadingDisplayValue = "Loading countries";
  }

  protected async firstUpdated(_changedProperties: Map<string | number | symbol, unknown>) {
    super.firstUpdated(_changedProperties);
    this.options = getCountryOptions(store.getState() as StoreState);
    if(!this.options){
      await store.dispatch(fetchCountryOptions()).unwrap()
        .catch(error => console.error("Failed to load country options",error));
      this.options = getCountryOptions(store.getState() as StoreState);
    }
    if(this.selectedOption){
      store.dispatch(updateSelectedCountry({id: this.type, country: this.selectedOption}));
    }
  }

  protected async updated(_changedProperties: Map<string | number | symbol, unknown>) {
    super.updated(_changedProperties);
    if(_changedProperties.has("selectedOption")){
      store.dispatch(updateSelectedCountry({id: this.type, country: this.selectedOption}));
    }
  }

  stateChanged(state: StoreState){
    this.isLoading = getCountryStatus(state) === ActionStatus.loading;
    if(getCountryStatus(state) === ActionStatus.failed){
      handleApiError(getCountryError(state));
      return;
    }
  }

  protected onSelectOption() {
    emit({
      element: this,
      name: 'mhecomm-country-selected',
      detail: {id: this.id, selectedCountry: this.selectedOption},
    })
  }

}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-country-selector': CountrySelect;
  }
}